import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=a073b9c0&scoped=true"
import script from "./Copy.vue?vue&type=script&lang=ts"
export * from "./Copy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a073b9c0",
  null
  
)

export default component.exports